module.exports = __webpack_public_path__ + "img/47_13.47371e5d.png";